import { StatusMoveDialog } from "./StatusMoveDialog";
import styles from "./Record.module.css";

interface CancelDialogProps {
  caseId: string;
  caseNo: string;
  title: string;
  /** Whom an open handover request goes to — a cancellation withdraws it. */
  pendingRecipient?: string | null;
  /**
   * The Vorgang is released (`quote_approved`): the server withdraws the
   * release with the cancel (E-52), and a restore leads back to planning —
   * so the way back is a new run and a new release. Said before, as the
   * facade gestures say it (screen check 15.10.2026, V-4).
   */
  released?: boolean;
  onClose: () => void;
  onDone: (sentence: string) => void;
  onClosed?: () => void;
}

/**
 * „Vorgang stornieren" (spec 2026-10-15 §5) — the delete button that deletes
 * nothing. The Vorgang leaves the start page and the register and stands under
 * „Beendet"; the reason is mandatory and comes back as the record's banner.
 * What the dialog does is `StatusMoveDialog`'s; this is its sentences.
 */
export function CancelDialog({ pendingRecipient = null, released = false, ...rest }: CancelDialogProps) {
  return (
    <StatusMoveDialog kind="cancel" {...rest}>
      <p className={styles.plain}>
        Der Vorgang verschwindet aus Start und Register und steht unter ‚Beendet‘. Gelöscht wird nichts — du kannst ihn
        wiederherstellen.
      </p>
      {released ? (
        <p className={styles.plain}>
          Die Freigabe wird dabei zurückgezogen — nach dem Wiederherstellen rechnest du neu und gibst neu frei.
        </p>
      ) : null}
      {pendingRecipient !== null ? (
        <p className={styles.plain}>Die offene Übergabe-Anfrage an {pendingRecipient} wird dabei zurückgezogen.</p>
      ) : null}
    </StatusMoveDialog>
  );
}
